<template>
  <BasicList
      headline="Sales Team"
      :data="project.attributes.project_sellers"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-show="() => false"
      :can-destroy="() => true"
      @destroy="destroy"
  >
    <template v-slot:default="{ row: projectSeller }">
      <td class="table__ellipsis">
        {{ projectSeller.user_full_name }}
      </td>
    </template>

    <template v-slot:modals>
      <CreateModal :project="project" @created="$emit('input', $event)"/>
    </template>

    <template v-slot:headline-right>
      <a href="#create-project-seller-modal" data-toggle="modal" class="btn btn-white btn-sm" style="margin-top: 4px;">
        <i class="fa fa-plus"></i> Add
      </a>
    </template>
  </BasicList>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import BasicList from '../../../Panels/Lists/Basic'
import CreateModal from "..//Modals/Create.vue";

export default {
  components: {CreateModal, BasicList},

  props: {
    project: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 20, text: 'User'},
      ]
    },
  },

  methods: {
    destroy(projectSeller) {
      modal.confirm('Are you sure that you want to remove the person from the sales team?', () => {
        http.delete('/api/v2/projects/' + this.project.id + '/project-sellers/' + projectSeller.user_id)
            .then(response => {
              notify.success('The user was removed from the sales team.')

              this.$emit('input', response.data.data)
            })
      })
    }
  }
}
</script>
